<script>
import SpecifyLocation from '@/components/organism/location/SpecifyLocation'

export default {
    name: 'Step6',
    components: {
        SpecifyLocation,
    },
    model: {
        prop: 'address',
        event: 'change',
    },
    props: {
        address: {
            type: Object,
            default: () => {},
        },
    },

    computed: {
        addressValue: {
            get() {
                return this.address
            },
            set(address) {
                this.$emit('change', { ...this.address, ...address })
            },
        },
    },
    methods: {
        verifyStep() {
            this.$refs.specifyLocation.verifyStep()
        },
        next() {
            this.$emit('next', 0)
        },
    },
}
</script>

<template lang="pug">             
specify-location(v-model="addressValue" @next="next" ref="specifyLocation")             
</template>
